import { IFrameWrapper } from '@memoresa/ui-components';
import { GetServerSideProps } from 'next';
import { useStaticCookies } from '../../utils/hooks/useStaticCookies';

const StaticPages: React.FC<{ url: string }> = ({ url }) => {
  const { cookieConsent } = useStaticCookies();

  return (
    <>
      {cookieConsent && (
        <IFrameWrapper
          url={`${url}${
            cookieConsent === 'all' ? '?cookies=true' : '?cookies=false'
          }`}
        />
      )}
    </>
  );
};
export const getServerSideProps: GetServerSideProps = async ({
  params,
  locale,
}) => {
  const path = params!.static as string;
  const validParams = [
    {
      path: 'agb',
      url: 'https://static.memoresa.de/agb-de',
      locale: 'de',
      key: 'terms',
    },
    {
      path: 'terms',
      url: 'https://static.memoresa.de/en/agb-en',
      locale: 'en',
      key: 'terms',
    },
    {
      path: 'widerruf',
      url: 'https://static.memoresa.de/widerruf-de',
      locale: 'de',
      key: 'revocation',
    },
    {
      path: 'revocation',
      url: 'https://static.memoresa.de/en/widerruf-en',
      locale: 'en',
      key: 'revocation',
    },
    {
      path: 'datenschutz',
      url: 'https://static.memoresa.de/privacy-de?cookies=false',
      locale: 'de',
      key: 'data-privacy',
    },
    {
      path: 'data-privacy',
      url: 'https://static.memoresa.de/privacy-en?cookies=false',
      locale: 'en',
      key: 'data-privacy',
    },
    {
      path: 'impressum',
      url: 'https://static.memoresa.de/imprint-de?cookies=false',
      locale: 'de',
      key: 'imprint',
    },
    {
      path: 'imprint',
      url: 'https://static.memoresa.de/imprint-en?cookies=false',
      locale: 'en',
      key: 'imprint',
    },
    {
      path: 'cookies-richtlinie',
      url: 'https://static.memoresa.de/cookies-richtlinie-eu-de',
      locale: 'de',
      key: 'cookies',
    },
    {
      path: 'cookies',
      url: 'https://static.memoresa.de/en/cookies-richtlinie-eu-en',
      locale: 'en',
      key: 'cookies',
    },
  ];
  if (!validParams.find(param => param.path === path)) {
    return {
      notFound: true,
    };
  }
  const validKey = validParams.find(param => param.path === path)!.key;
  const isValidPath =
    validParams.find(
      param => param.key === validKey && locale === param.locale
    )!.path === path;

  if (!isValidPath) {
    return {
      redirect: {
        permanent: false,
        destination: `/${locale}/${
          validParams.find(
            param => param.key === validKey && locale === param.locale
          )!.path
        }`,
      },
    };
  }

  return {
    props: {
      url: validParams.find(
        param => param.key === validKey && locale === param.locale
      )!.url,
    },
  };
};
export default StaticPages;
